import { Controller } from "@hotwired/stimulus"

// Handles fetching paginated lists via Stimulus, so pagination/search stay within the page.
export default class extends Controller {
  static targets = ["list", "form"]
  static values = { url: String }

  connect() {
    if (!this.hasUrlValue) {
      this.urlValue = this.element.dataset.paginatedListUrl
    }

    // Ensure we have a base URL for requests
    if (!this.urlValue && this.hasFormTarget) {
      this.urlValue = this.formTarget.action
    }
  }

  search(event) {
    if (event.type === "submit") event.preventDefault()
    this.queueFetch(this.searchUrl())
  }

  goToPage(event) {
    event.preventDefault()
    const url = event.currentTarget.dataset.paginatedListUrl || event.currentTarget.href
    this.queueFetch(url)
  }

  queueFetch(url) {
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => this.fetch(url), 200)
  }

  async fetch(url) {
    if (!url) return

    this.showLoadingState()

    try {
      const response = await fetch(url, {
        headers: { "X-Requested-With": "XMLHttpRequest" }
      })

      if (!response.ok) throw new Error(`${response.status}: ${response.statusText}`)

      const html = await response.text()
      this.listTarget.innerHTML = html
    } catch (error) {
      console.error("Paginated list fetch failed", error)
    } finally {
      this.hideLoadingState()
    }
  }

  showLoadingState() {
    this.listTarget.classList.add("opacity-50", "pointer-events-none")
  }

  hideLoadingState() {
    this.listTarget.classList.remove("opacity-50", "pointer-events-none")
  }

  searchUrl() {
    if (!this.hasFormTarget) return this.urlValue
    const formData = new FormData(this.formTarget)
    const params = new URLSearchParams(formData)
    return `${this.urlValue}?${params.toString()}`
  }
}
